package com.gsb.vyapar.bhagya.presentation.splash.manager

import com.gsb.vyapar.bhagya.datasource.mqtt.MQTTManager
import com.gsb.vyapar.bhagya.datasource.preference.Preference
import com.gsb.vyapar.bhagya.interactor.manager.StateManager.launchDefault
import kotlinx.coroutines.delay
import com.gsb.vyapar.bhagya.presentation.splash.event.SplashUiEvents
import com.gsb.vyapar.bhagya.presentation.splash.event.SplashUiEvents.*
import com.gsb.vyapar.bhagya.presentation.splash.util.*
import com.gsb.vyapar.bhagya.util.BuildConfig
import com.gsb.vyapar.bhagya.util.PlatformType

object SplashManager {
    fun onTriggerEvent(event: SplashUiEvents) {
        when (event) {
            is GetSplashUiData -> {
                launchDefault {
                    val businessNumber = getLastBusinessNumber()
                    checkToken()
                    if (!Preference.copyToSql) {
                        copyBusinessesToSql()
                        Preference.copyToSql = true
                    }
                    getConfig()
                    getCategories()
                    getSubCategories()
                    getInfo()
                    getBusinesses(businessNumber)
                    delay(3000)
                    getAllTheBusiness()
                    checkVersion(event.uriHandler)
                    MQTTManager.createMqttClient()
                }
            }
        }
    }
}